import { print } from 'graphql';
import { CREATE_BANNER, UPDATE_BANNER, DELETE_BANNER, GET_BANNERS } from '../bannerGQL';
import { Banner, BannerInput } from '../../interfaces/product';

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_API_PRODUCT_URL!;

// Helper: Get Authorization headers from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: token ? `Bearer ${token}` : '',
  };
};

// FETCH
export const fetchBanners = async (): Promise<Banner[]> => {
  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({ query: print(GET_BANNERS) }),
  });
  const { data, errors } = await res.json();
  if (errors?.length) throw new Error(errors[0].message);
  return data.banners;
};

// CREATE
export const createBanner = async (input: BannerInput): Promise<Banner> => {
  const { imageFile, ...rest } = input;
  const variables = { input: { ...rest, image: null } };

  const form = new FormData();
  form.append(
    'operations',
    JSON.stringify({
      query: print(CREATE_BANNER),
      variables,
    })
  );
  form.append('map', JSON.stringify({ '0': ['variables.input.image'] }));
  if (imageFile) form.append('0', imageFile);

  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(), // Do NOT set 'Content-Type' with FormData
    },
    body: form,
  });

  const { data, errors } = await res.json();
  if (errors?.length) throw new Error(errors[0].message);
  return data.createBanner;
};

// UPDATE
export const updateBanner = async (id: string, input: BannerInput): Promise<Banner> => {
  const { imageFile, ...rest } = input;
  const variables = { input: { id, ...rest, image: null } };

  const form = new FormData();
  form.append(
    'operations',
    JSON.stringify({
      query: print(UPDATE_BANNER),
      variables,
    })
  );
  form.append('map', JSON.stringify({ '0': ['variables.input.image'] }));
  if (imageFile) form.append('0', imageFile);

  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      ...getAuthHeaders(),
    },
    body: form,
  });

  const { data, errors } = await res.json();
  if (errors?.length) throw new Error(errors[0].message);
  return data.updateBanner;
};

// DELETE
export const deleteBanner = async (id: string): Promise<boolean> => {
  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({
      query: print(DELETE_BANNER),
      variables: { id },
    }),
  });
  const { data, errors } = await res.json();
  if (errors?.length) throw new Error(errors[0].message);
  return data.deleteBanner;
};

// Generic GraphQL query executor
export async function fetchGraphQL(query: string, variables: any = {}) {
  const res = await fetch(GRAPHQL_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  const json = await res.json();
  if (json.errors?.length) throw new Error(json.errors[0].message);
  return json.data;
}
